import {ExcludeMicaParams} from '../../types/interfaces/configuration';

export class FetchExcludeMicaParamsList {
  static readonly type = '[ListMicaProductParams] Fetch All';

  constructor(public payload: ExcludeMicaParams) {
  }
}
